<template>
  <a-modal
    title="编辑设备分组"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['id']" read-only />
        </a-form-item>
        <a-form-item label="分组名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['group_name', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceGroupApi from '@/api/device-group'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show({ id, group_name }) {
      this.visible = true
      this.$nextTick(()=>{
          this.form.setFieldsValue({ id, group_name })
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          DeviceGroupApi.edit({
            id: values.id,
            group_name: values.group_name
          })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('操作成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
